import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";

import { handleMarvinFormOpen, getDevice } from "../../IFormDesignerLogic";
import { useMediaQuery } from '@material-ui/core';
import { GetStateFromData } from '../../../CustomHooks/CustomHooks.js'


const useStyles = makeStyles(() => ({
  container: {
    display:  style=>style.deviceType === "mobile" && !style.isContainer ? "" : "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    verticalAlign: "middle",
    gap: "8%"
  },
  subContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: style=>style.deviceType === "mobile" ? "35px" : ""
  },
  generatePageText: {
    "text-align": "center",
    color: "#000",
    "font-family": "Open Sans",
    "font-size": style=>style.deviceType === "mobile" ? "10px" :"16px",
    "font-style": "normal",
    "font-weight": "600",
    "line-height": style=>style.deviceType === "mobile"? "14px" : "22px",
    "margin-bottom": style=>style.deviceType === "mobile"? "8px" :"12px"
  },
  button: {
    // width: "25%",
    fontSize: style=>style.deviceType === "mobile" ? "8px !important": "12px !important",
    border: "1px solid #0072c655 !important",
    borderRadius: "2px !important",
    margin: "0 !important",
    padding: "0px 12px !important",
    height: style=>style.deviceType === "mobile" ? "18px !important" : "auto !important",
    display: style=>style.deviceType === "mobile" ? "flex" : null,
    alignItems: style=>style.deviceType === "mobile" ? "center" : null,
    lineHeight: style=>style.deviceType === "mobile" ? "normal !important" : null,
    fontWeight: "700 !important"
  },
  secondaryButton: {
    backgroundColor: "#fff !important",
    color: "#0072C6 !important",
    border: "1px solid #0072C6 !important"
  },
  textStyle: {
    "text-align": "center",
    color: "#3A3A3A",
    // "text-align": "center",
    "font-family": "Open Sans",
  "font-size": style=>style.deviceType === "mobile" ? "8px":"12px",
  "font-style": "normal",
  "font-weight": "400",
  "line-height": style=>style.deviceType === "mobile"? "10px": "16px",
  "margin-bottom":style=>style.deviceType === "mobile" ? "10px": "16px"
  },
  pageTemplateText: {
    color: "#0072C6",
    "font-family": "Open Sans",
    "font-size":style=>style.deviceType === "mobile" ? "8px": "12px",
    "font-style": "normal",
    "font-weight": "600",
    "line-height": "16px",
    "text-decoration-line": "underline",
    cursor: "pointer"
  },
  pageMarvinText: {
    "text-align": "center",
    color: "#000",
  "font-family": "Open Sans",
  "font-size": style=>style.deviceType === "mobile" ? "8px" : "12px",
  "font-style": "normal",
  "font-weight": "400",
  "line-height": "normal",
  "margin-bottom": style=>style.deviceType === "mobile" ? "10px": "16px"
  }
}));

const GeneratePage = (props) => {
  const marvinContexts = GetStateFromData(props?.containerId, "marvinData");
  const { marvinButtonSelected } = marvinContexts.marvinStates;
  const matches = useMediaQuery("(min-width: 1181px)");
  const pageOrForm = props?.isPortal ? props?.activePage ? "Page" : "Subform" : "Form"
  const deviceType = getDevice()
  const classes = useStyles({deviceType,isContainer:props?.addContainer});
  const { t } = useTranslation();

  const addContainer = () => {
    window.changeDrawer("open", true);
    props?.setAddContainer(true);
  };

  const generatePageFunction = () => {
    props?.setGeneratePage(true);
    handleMarvinFormOpen(props.containerId, props.controlSelected, true);          
  };

  return (
    <div className={classes.container}>
      {!props?.generatePage  && (
        <div className={classes.subContainer}>
          <img
            src={require(`../../../../Icons/Marvin/generatePage.svg`).default}
            style={{
              width: deviceType === "mobile"? "112px" : "178.001px",
              height: deviceType === "mobile" ? "106px" : "169px"
            }}
          />
          <span className={classes.generatePageText}>{t(props?.addContainer ? "Drag & Drop Containers":"Start with adding container or a template")}</span>
          <span className={classes.textStyle}>
            {t(props?.addContainer ? "Start creating interface by dropping the container on the canvas":"Add one of the container to start adding controls or select ")}
            {!props?.addContainer && <span className={classes.pageTemplateText} onClick={() => props?.handleTemplate("open")}>
              {t("Page Templates")}
            </span>}
          </span>

          {!props?.addContainer &&<Button
            type="button"
            appearance="secondary"
            className={[classes.button, classes.secondaryButton].join(" ")}
            onClick={() => addContainer()}
          >
            {"+Add Container"}
          </Button>}
        </div>
      )}

      {!props?.generatePage && !props?.addContainer && props?.isMarvinEnabled && (deviceType === "mobile" ? 
      <div style={{display: "flex", padding: "1px 35px"}}>
        <div style={{height: "2px", width: "44%", margin: "10px 0",background: "rgba(196, 196, 196, 1)"}}/>
        <div style={{fontSize: "16px", fontWeight: "600", margin: "0px 12px", color: "rgba(0, 0, 0, 1)"}}>OR</div>
        <div style={{height: "2px", width: "44%", margin: "10px 0",background: "rgba(196, 196, 196, 1)"}}/>
        </div> 
        : <img src={require(`../../../../Icons/Marvin/marvinDivider.svg`).default} />)}

      {(!props?.addContainer && props?.isMarvinEnabled) && <div className={classes.subContainer} style={{ marginTop: "-6%",width:marvinButtonSelected && !props?.addContainer && props?.generatePage && !matches ? "257px":null }}>
        <img src={require(`../../../../Icons/Marvin/generatePageMarvin.svg`).default} />
        <span className={classes.generatePageText}>{t(`Ask Marvin to generate ${pageOrForm}`)}</span>
        <span className={classes.pageMarvinText}>{t(`Give your ${pageOrForm?.toLowerCase()} name and some inputs to generate ${pageOrForm}`)}</span>
        {!props?.generatePage && (
          <Button
            type="button"
            appearance="secondary"
            className={[classes.button, classes.secondaryButton].join(" ")}
            onClick={() => generatePageFunction()}
          >
            {`Generate ${pageOrForm}`}
          </Button>
        )}
      </div>}
    </div>
  );
};

export default GeneratePage;
